import Modal from "react-modal";
import CopyAnimationComponent from "../../assets/lottie/CopyAnimation/CopyAnimationComponent";
import { copyToClipboard } from "../../_helper";
import ShareAnimationComponent from "../../assets/lottie/ShareAnimation/ShareAnimationComponent";

Modal.setAppElement("#root");

const SaleLinkModal = ({ title, icon, value, isOpen, onClose }) => {
  const shareContent = () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Check this out!",
          text: "This is some content I want to share with you.",
          url: window.location.href,
        })
        .then(() => console.log("Content shared successfully"))
        .catch((error) => console.log("Error sharing:", error));
    } else {
      alert("Share feature is not supported on this browser/device.");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="tw-bg-white tw-py-10 tw-px-5 tw-rounded-xl tw-shadow-lg !tw-outline-none tw-mx-auto md:!tw-w-[50%] xl:!tw-w-[30%]"
      overlayClassName="tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-justify-center tw-items-center"
    >
      <h2 className="tw-text-lg tw-font-bold tw-text-center">
        <span className="tw-me-2 tw-inline-block">{icon}</span>
        <span>{title}</span>
      </h2>
      <p className="tw-text-primary tw-text-center tw-py-7 tw-text-xl tw-break-words">
        {value}
      </p>
      <div className="tw-flex tw-justify-around tw-text-black tw-font-medium">
        <div className="tw-flex tw-flex-col tw-items-center">
          <div className="tw-grid tw-bg-primary tw-rounded-full tw-w-12 tw-h-12">
            <CopyAnimationComponent
              className="tw-m-auto tw-w-10 "
              onClick={copyToClipboard}
              link={value}
            />
          </div>
          <p>Copy</p>
        </div>
        <div className="tw-flex tw-flex-col tw-items-center">
          <div
            className="tw-grid tw-bg-[#E0E0E0E0] tw-rounded-full tw-w-12 tw-h-12 tw-cursor-pointer"
            onClick={shareContent}
          >
            <ShareAnimationComponent className="tw-m-auto " />
          </div>
          <p>Share</p>
        </div>
      </div>
    </Modal>
  );
};

export default SaleLinkModal;
